// -----
// *** INTERFACES ***
// -----
export interface ActionChange {
  brickId: string; // Can be brick ID or set ID (sets have hyphen: "6772-1")
  baseChangeValue: number;
  type?: "brick" | "set"; // Optional: defaults to "brick" for backward compatibility
}

export interface ActionVisibility {
  actionId: string;
}

export interface ActionInfo {
  id: string;
  type:
    | "Collect"
    | "Create"
    | "Split"
    | "Capacity"
    | "Auto Collect"
    | "BrickPack"
    | "Upgrade"
    | "BuySet";
  title: string;
  details: string | null;
  cost: ActionChange[];
  costIncrement: number;
  outcome: ActionChange[];
  actionVisibility: ActionVisibility[];
  isBrickpack: boolean;
}

// -----
// *** DEFAULT ACTION ***
// -----
export const defaultAction: ActionInfo = {
  id: "default_action",
  type: "Collect",
  title: "Default Action",
  details: null,
  cost: [],
  costIncrement: 1,
  outcome: [],
  actionVisibility: [],
  isBrickpack: false,
};
